const MAX = 6;
const buildOptions = function (array = []) {
  for (let i = 1; i <= MAX; i++) {
    array.push({ label: `${i}+`, id: i });
  }
  return array;
};

export const bedOptions = buildOptions([{ label: 'Studio', id: '0' }]);
export const bathOptions = buildOptions();
